import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-zinc-100">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0b0b0b",
            border: "1px solid rgba(255,107,0,0.35)",
            color: "#f2f2f2",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
